import React, { useEffect, useState } from "react";
import {
  NavLink,
  useRouteMatch,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

import CreatedList from "./CreatedList";
import InProcessList from "./InProcessList";
import { useTranslation } from "react-i18next";
function AutoriaList({ path, search }) {
  const { t } = useTranslation();
  return (
    <div className="autoria--list">
      <div className="header--list">
        {" "}
        <h3>{t("services.copyright.table.header")}</h3>
        <div className="nav">
          <NavLink
            to={`/services/autorship-proof/created`}
            className="NavLink--services"
            activeClassName="NavLink--services--active"
          >
            {t("services.copyright.table.created")}
          </NavLink>
          <NavLink
            to={`/services/autorship-proof/in-process`}
            className="NavLink--services"
            activeClassName="NavLink--services--active"
          >
            {t("services.copyright.table.inProcess")}
          </NavLink>
        </div>
      </div>
      <div>
        <Switch>
          <Route path={`${path}/created`}>
            <CreatedList search={search} />
          </Route>
          <Route path={`${path}/in-process`}>
            <InProcessList search={search} />
          </Route>
          <Redirect from={path} to={`${path}/created`} />
        </Switch>
      </div>
    </div>
  );
}

export default AutoriaList;
